/* mixins/form */
export default {
    methods: {
        getFormData(form) {
            if (form === null) return null

            var result = new Object()

            for (var key in form) {
                if (Object.prototype.hasOwnProperty.call(form, key)) {
                    if (form[key] !== null)
                        result[key] = form[key]
                }
            }

            return result
        },

        isValidUri(uri) {
            try {
                new URL(uri)
            } catch (_) {
                return false
            }

            return true
        },

        resetFormData(form) {
            if (form === null) return

            for (var key in form) {
                if (Object.prototype.hasOwnProperty.call(form, key)) {
                    form[key] = null
                }
            }
        },

        validHours(time, allowZero = false) {
            let hours = parseFloat(time)

            if (isNaN(hours) || hours === null) return false
            if (allowZero && hours === 0) return true
            if (hours < 0.5 || time % .5 !== 0) return false

            return true
        },

        validNumber(num) {
            return num !== '' || num === 0
        }
    }
}